// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__MaP13","closeButton":"Accordion_closeButton__3MQgO","collapsable":"Accordion_collapsable__GOBzT","spindindust":"Accordion_spindindust__3BJp-"};